import { HTTPClient } from "./Client";

const CoordenadoresApi = {

    async ObterCoordenadoresPorIdAsync(coordenadorId) {
        const response = await HTTPClient.get(`/Coordenadores/ObterCoordenadorId/${coordenadorId}`);
        return response.data;
    },

    async DeletarCoordenadorAsync(coordenadorId) {
        const response = await HTTPClient.put(`/Coordenadores/DeletarCoordenador/${coordenadorId}`);
        return response.data;
    },

    async EditarCoordenadorAsync(coordenadorId, nomeCompleto, nomeContato, cpf, rg, dataDeNascimento, status) {
        const coordenador = {
            nomeCompleto: nomeCompleto,
            nomeContato: nomeContato,
            cpf: cpf,
            rg: rg,
            dataDeNascimento: dataDeNascimento,
            status: Number(status)
        }

        const response = await HTTPClient.put(`/Coordenadores/AtualizarCoordenador/${coordenadorId}`, coordenador);
        return response.data;
    },

    // async AdicionarCoordenadorAsync(nomeCompleto, email, senha, confirmarSenha, grupoDeUsuario) {

    //     const coordenadorCriar = {
    //         NomeCompleto: nomeCompleto,
    //         Email: email,
    //         Senha: senha,
    //         ConfirmarSenha: confirmarSenha,
    //         GrupoDeUsuarioId: grupoDeUsuario
    //     };

    //     await HTTPClient.post('/Coordenadores/AdicionarCoordenador', coordenadorCriar);
    // },

    async AtualizarCoordenadorAsync(usuario) {
        const { id, nomeCompleto, status, grupoDeUsuarioId } = usuario;

        const coordenadorAtualizar = {
            Id: id,
            NomeCompleto: nomeCompleto,
            Status: parseInt(status),
            GrupoDeUsuarioId: grupoDeUsuarioId
        };

        await HTTPClient.put(`/Coordenadores/AtualizarCoordenador`, coordenadorAtualizar);
    },

    async ListarStatusUsuarioAsync() {
        const response = await HTTPClient.get(`/Usuario/ListarStatusUsuario`);
        return response.data;
    },


    async ListarCoordenadoresComPaginacaoAsync(pagina, nome, email) {
        const coodernadoresComPaginacao = {
            Pagina: pagina,
            Nome: nome,
            Email: email
        };

        const response = await HTTPClient.post(`/Coordenadores/ListarCoordenadores`, coodernadoresComPaginacao);
        return response.data;
    },
}

export default CoordenadoresApi;